<mat-toolbar class="no-background">
  <span>出金依頼の詳細</span>
  <span class="spacer"></span>
  <a mat-button class="add-link" routerLink="/withdrawal">
    <mat-icon>arrow_back</mat-icon>戻る
  </a>
</mat-toolbar>

<div class="inquiry-container" *ngIf="inquiry">

  <div class="inquiry-header">
    <div class="inquiry-title">口座番号・他 : {{ inquiry.title }}</div>
    <div class="inquiry-meta">
      <app-label-chip [status]="inquiry.status"></app-label-chip>
    </div>
  </div>

  <div class="complete-section" *ngIf="!['完了', '取消', '出金額確定', '出金済'].includes(inquiry.status) || (inquiry.status === '出金額確定' && inquiry.withdrawal_transaction.details.length === 0)">
    <div>
      <span class="complete-message">
        出金依頼を取り消したい場合は、下記にチェックを入れて「取消」を押してください<br>
        ・状態が「出金済」になっている場合は取り消しできません<br>
        ・状態が「出金額確定」でも、分割出金が始まっていなければ取り消し可能です<br>
        ・分割出金が始まっている場合は、ここでは取消ができませんのでご相談ください<br>
      </span>
      <label for="visibleCancelCheck" style="margin-top: 8px;"><input type="checkbox" id="visibleCancelCheck" [(ngModel)]="visibleCancelButton">出金依頼を取り消します</label>
    </div>
    <button mat-raised-button color="accent" type="button" [disabled]="!visibleCancelButton" (click)="markAsCanceled()">取消</button>
  </div>

  <div class="child-list">
    <div class="child-item" *ngFor="let child of inquiry.children">
      <div class="child-header">
        <strong>{{ getUserName(child.user_id) }}</strong>
        <span class="child-date">{{ child.created_at | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
      </div>
      <div class="child-body">{{ child.body }}</div>

      <div *ngIf="child.attachments && child.attachments.length > 0">
        <h4>添付ファイル :</h4>

        <ul class="attachments">
          <li *ngFor="let file of child.attachments">
            <a (click)="downloadAttachment(file.id)" class="attachment-link">
              <mat-icon>file_open</mat-icon>{{ file.filename }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="" *ngIf="inquiry.status === '出金額確定' || inquiry.status === '出金済'">
    <div style="margin-top: 8px; font-weight: bold;">
      送金履歴
      （出金確定額：{{inquiry.withdrawal_transaction.currency}} {{formatAmount(inquiry.withdrawal_transaction.requested_amount, inquiry.withdrawal_transaction.currency)}} /
      送金済額：{{inquiry.withdrawal_transaction.currency}} {{formatAmount(inquiry.withdrawal_transaction.settled_amount, inquiry.withdrawal_transaction.currency)}} /
      未送金額：{{inquiry.withdrawal_transaction.currency}} {{formatAmount(inquiry.withdrawal_transaction.unpaid_amount, inquiry.withdrawal_transaction.currency)}}）
    </div>
    <table class="transaction-details">
      <tr>
        <th>送金日</th>
        <th>銀行への送金額（{{inquiry.withdrawal_transaction.currency}}）</th>
        <th>送金手数料（{{inquiry.withdrawal_transaction.currency}}）</th>
        <th>合計（{{inquiry.withdrawal_transaction.currency}}）</th>
      </tr>

      @if (inquiry.withdrawal_transaction.details.length > 0) {
      <tr *ngFor="let detail of inquiry.withdrawal_transaction.details">
        <td class="detail-date">{{formatDate(detail.transaction_date.toString(), true)}}</td>
        <td class="detail-amount">{{formatAmount(detail.amount_gross, inquiry.withdrawal_transaction.currency)}}</td>
        <td class="detail-amount">{{formatAmount(detail.fee, inquiry.withdrawal_transaction.currency)}}</td>
        <td class="detail-amount">{{formatAmount(detail.amount_net, inquiry.withdrawal_transaction.currency)}}</td>
      </tr>
      } @else {
        <tr><td colspan="4" style="text-align: center;">まだありません（出金依頼の取り消しが可能です）</td></tr>
      }
    </table>
  </div>

  <div class="complete-section" *ngIf="inquiry.status === '出金済' && inquiry.withdrawal_transaction.unpaid_amount <= 0">
    <div>
      <span class="complete-message">出金手続きが完了した場合は、下記にチェックを入れて「完了」を押してください</span>
      <label for="visibleCompleteCheck" style="margin-top: 8px;"><input type="checkbox" id="visibleCompleteCheck" [(ngModel)]="visibleCompleteButton">出金依頼を完了します</label>
    </div>
    <button mat-raised-button color="accent" type="button" [disabled]="!visibleCompleteButton" (click)="markAsCompleted()">完了</button>
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()" enctype="multipart/form-data" *ngIf="inquiry.status !== '完了' && inquiry.status !== '取消' && inquiry.status !== '処理済'">

    <div style="height: 16px;">&nbsp;</div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>返信（1000文字まで）</mat-label>
      <textarea matInput formControlName="body" rows="6" required></textarea>
      <mat-hint align="end">
        <span *ngIf="form.get('body')?.invalid && form.get('body')?.touched" class="inline-error">
          返信は必須です　
        </span>
        <span *ngIf="form.get('body')?.hasError('maxlength') && form.get('body')?.touched" class="inline-error">
          返信は1000文字以内で入力してください　
        </span>
        {{ form.get('body')?.value?.length || 0 }}/1000
      </mat-hint>
    </mat-form-field>

    <input type="file" #fileInput hidden multiple (change)="onFileChange($event)" />

    <div class="drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <p>ここにファイルをドロップまたは</p>
      <button mat-raised-button color="primary" type="button" (click)="fileInput.click()">ファイルを選択</button>
      <p></p>
      <p>※ファイルは最大10個まで、1ファイルにつき20MB以内でアップロードしてください</p>

      <mat-list>
        <mat-list-item *ngFor="let file of selectedFiles; let i = index">
          <div class="file-row">
            <button mat-icon-button color="warn" type="button" (click)="removeFile(i)" aria-label="削除">
              <mat-icon>delete</mat-icon>
            </button>
            <span class="file-size">
              ({{ file.size / (1024 * 1024) | number : '1.2-2' }} MB)
            </span>
            <span class="file-name">
              {{ file.name }}
            </span>
          </div>
        </mat-list-item>
      </mat-list>

    </div>

    <div class="upload-hint">
      <mat-hint align="end">{{ selectedFiles.length || 0 }}/10</mat-hint>
    </div>

    <mat-error *ngIf="form.get('files')?.hasError('maxFileSize')">
      {{ form.get('files')?.getError('maxFileSize')?.message }}
    </mat-error>

    <div style="text-align: right;">
      <button mat-raised-button color="primary" type="submit" [disabled]="form.invalid">
        返信を登録
      </button>
    </div>

  </form>
</div>
